import React, { useState } from 'react';
import moment from 'moment-timezone';
import ISO6391 from 'iso-639-1';
import TextField from '@material-ui/core/TextField';
import * as i18n from "../common/i18n";
import Chips from "../common/Chips";
import CustomTableCell from '../common/CustomTableCell';
import CustomFilterRow from '../common/CustomFilterRow';
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Signal0BarIcon from '@material-ui/icons/SignalCellular0Bar';
import Signal1BarIcon from '@material-ui/icons/SignalCellular1Bar';
import Signal2BarIcon from '@material-ui/icons/SignalCellular2Bar';
import Signal3BarIcon from '@material-ui/icons/SignalCellular3Bar';
import Signal4BarIcon from '@material-ui/icons/SignalCellular4Bar';
import SignalNoInternetIcon from '@material-ui/icons/SignalCellularConnectedNoInternet0Bar';
import BatteryCharging20Icon from '@material-ui/icons/BatteryCharging20';
import Battery20Icon from '@material-ui/icons/Battery20';
import Battery30Icon from '@material-ui/icons/Battery30';
import Battery50Icon from '@material-ui/icons/Battery50';
import Battery60Icon from '@material-ui/icons/Battery60';
import Battery80Icon from '@material-ui/icons/Battery80';
import Battery90Icon from '@material-ui/icons/Battery90';
import BatteryFullIcon from '@material-ui/icons/BatteryFull';
import BatteryUnknownIcon from '@material-ui/icons/BatteryUnknown';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import { EventCode, AlertStatus } from "../common/constants"
import FilterIcon from '@material-ui/icons/FilterList';
import Box from '@material-ui/core/Box';
import { DateRangePicker } from 'react-dates';
import { debounce } from 'lodash';
import Input from '@material-ui/core/Input';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';


var deepEqual = require('deep-equal');



export const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


export const set = (object, data, key, fn) => {
    if (data[key] && data[key] !== null) {
        object[key] = fn ? fn(data[key]) : data[key];
    }
}

export const orderByString = (query, mapField, defaultID, collation) => {

    const direction = query["orderDirection"] === "asc" ? "ASC" : "DESC";
    const orderByfield = query["orderBy"] === undefined ? defaultID : query["orderBy"]["field"];
    const _collation = collation === undefined ? false : collation;

    let str = ""

    str += `{column: "${mapField(orderByfield)}", direction: ${direction}, collation:${_collation}}`;
    return `[${str}]`;
}

export const whereString = (filters, mapField, exact) => {
    let str = '';

    for (const filter of filters) {
        if (filter['column']['type'] === 'numeric') {
            if (typeof filter['value'] === 'object') {
                if (filter["value"]["from"]) str += `{column: "${mapField(filter['column']['field'])}", comparator: GTE, float: ${filter['value']['from']}},`;
                if (filter["value"]["to"]) str += `{column: "${mapField(filter['column']['field'])}", comparator: LTE, float: ${filter['value']['to']}},`;
            } else {
                str += `{column: "${mapField(filter['column']['field'])}", comparator:${filter['column']['comparator']}, float: ${filter['value']
                    }},`;
            }
        } else if (filter['column']['type'] === 'datetime' || filter['column']['type'] === 'date') {
            if (typeof filter['value'] === 'object') {
                if (filter['value'].startDate) {
                    str += `{column: "${mapField(filter['column']['field'])}", comparator: GTE, datetime: ${moment(
                        filter['value'].startDate
                    ).unix()}},`;
                }
                if (filter['value'].endDate) {
                    str += `{column: "${mapField(filter['column']['field'])}", comparator: LTE, datetime: ${moment(
                        filter['value'].endDate
                    ).unix()}},`;
                }
            } else {
                str += `{column: "${mapField(filter['column']['field'])}", comparator:${filter['column']['comparator']
                    } ,datetime: ${moment(filter['value']).unix()}},`;
            }
        } else if (filter['column']['type'] === 'boolean') {
            str += `{column: "${mapField(filter['column']['field'])}", comparator: IS, boolean: ${filter['value'] === 'checked'
                }},`;
        } else if (filter['column']['lookup'] !== undefined && filter['value'].length > 0) {
            str += `{column: "${mapField(filter['column']['field'])}", comparator: IN, values: [${filter['value'].map(
                (value) => `"${value}"`
            )}]},`;
        } else if (filter['column']['lookup'] === undefined) {
            const array = exact ? exact : [];

            if (array.includes(mapField(filter['column']['field']))) {
                str += `{column: "${mapField(filter['column']['field'])}", comparator: IS, string: "${filter['value']}"},`;
            } else {
                if (Array.isArray(filter['value'])) {
                    // eslint-disable-next-line
                    filter['value'].forEach((value) => {
                        str += `{column: "${mapField(filter['column']['field'])}", comparator: ${filter['column']['comparator'] || 'LIKE_OR'
                            }, string: "${value}"},`;
                    });
                } else {
                    str += `{column: "${mapField(filter['column']['field'])}", comparator: LIKE, string: "${filter['value']}"},`;
                }
            }
        }
    }
    return `[${str}]`;
};

export const getLanguages = () => {
    const languages = {};
    ISO6391.getLanguages(ISO6391.getAllCodes()).map(lang => {
        return languages[lang.code] = lang.nativeName;
    })
    return languages;
}

export const getTimeZones = () => {
    const timeZones = {};
    moment.tz.names().map(tz => {
        return timeZones[tz] = tz;
    })
    return timeZones;
}

export const batteryIconOf = (battery) => {

    if (battery) {
        if (battery === 100) {
            return <Tooltip title={`${battery} % `} arrow>
                <BatteryFullIcon />
            </Tooltip >

        } else if (battery >= 90) {
            return <Tooltip title={`${battery} % `} arrow>
                <Battery90Icon />
            </Tooltip >

        } else if (battery >= 80) {
            return <Tooltip title={`${battery} % `} arrow>
                <Battery80Icon />
            </Tooltip>

        } else if (battery >= 60) {
            return <Tooltip title={`${battery} % `} arrow>
                <Battery60Icon />
            </Tooltip>

        } else if (battery >= 50) {
            return <Tooltip title={`${battery} % `} arrow>
                <Battery50Icon />
            </Tooltip>

        } else if (battery >= 30) {
            return <Tooltip title={`${battery} % `} arrow>
                <Battery30Icon />
            </Tooltip>

        } else if (battery >= 20) {
            return <Tooltip title={`${battery} % `} arrow>
                <Battery20Icon />
            </Tooltip>

        } else {
            return <Tooltip title={`${battery} % `} arrow>
                <BatteryCharging20Icon />
            </Tooltip>
        }

    } else {
        return <Tooltip title={`N/A`} arrow>
            <BatteryUnknownIcon />
        </Tooltip>


    }
}

export const eventChipOf = (code, id) => {

    if (code) {
        let color = "primary";
        switch (code) {
            case "DISTANCE_ERROR":
            case "FLOW_ERROR":
            case "OUTOFBOUNDS_ERROR":
            case "BATTERY_LOW":
            case "SERVER_ERROR":
            case "UPDATE_ERROR":
            case "GENERAL_ERROR":
            case "SENSOR_ERROR_FLOW":
            case "SENSOR_ERROR_DISTANCE":
            case "SENSOR_ERROR_TEMPERATURE":
            case "VALVE_ERROR":
                color = "secondary"
                break;
            default:
                color = "primary"
        }
        return <Chip label={EventCode[code]} variant={'outlined'} color={color} style={{ marginRight: 8, marginBottom: 8 }} />
    } else {
        return null;
    }
}

export const noColorEventChipOf = (code) => {

    if (code) {

        return <Chip label={EventCode[code]} value={code} variant={'outlined'} style={{ marginRight: 8, marginBottom: 8 }} />
    } else {
        return null;
    }
}

export const alertStatusChipOf = (status) => {
    if (status) {
        let color = "primary";
        switch (status) {
            case "NEW":
                color = "secondary"
                break;
            default:
                color = "primary"
        }
        return <Chip label={`${AlertStatus[status]}`} value={status} variant={'outlined'} color={color} style={{ marginRight: 8, marginBottom: 8 }} />
    } else {
        return null;
    }
}

export const tenantChipOf = (company, id) => {

    if (company && id) {

        return <Chip label={`${company} (${id})`} value={id} variant={'outlined'} style={{ marginRight: 8, marginBottom: 8 }} />
    } else {
        return null;
    }
}

export const buildingChipOf = (street, id) => {

    if (street && id) {

        return <Chip label={`${street}`} value={id} variant={'outlined'} style={{ marginRight: 8, marginBottom: 8 }} />
    } else {
        return null;
    }
}

export const parcelChipOf = (name, id) => {

    if (name && id) {

        return <Chip label={`${name} (${id})`} value={id} variant={'outlined'} style={{ marginRight: 8, marginBottom: 8 }} />
    } else {
        return null;
    }
}

export const tapChipOf = (name, id, valve) => {

    if (name && id) {
        if (valve) {
            return <Chip label={`${name} ${valve} (${id})`} value={id} variant={'outlined'} style={{ marginRight: 8, marginBottom: 8 }} />
        } else {
            return <Chip label={`${name} (${id})`} value={id} variant={'outlined'} style={{ marginRight: 8, marginBottom: 8 }} />
        }
    } else {
        return null;
    }
}

export const signalBarIconOf = (rssi) => {

    if (rssi) {
        if (rssi > -70) {
            return <Tooltip title={rssi} arrow>
                <Signal4BarIcon />
            </Tooltip>


        } else if (rssi > -85) {
            return <Tooltip title={rssi} arrow>
                <Signal3BarIcon />
            </Tooltip>

        } else if (rssi > -100) {
            return <Tooltip title={rssi} arrow>
                <Signal2BarIcon />
            </Tooltip>

        } else if (rssi > -110) {
            return <Tooltip title={rssi} arrow>
                <Signal1BarIcon />
            </Tooltip>

        } else {
            return <Tooltip title={rssi} arrow>
                <Signal0BarIcon />
            </Tooltip>
        }

    } else {
        return <Tooltip title={"N/A"} arrow>
            <SignalNoInternetIcon />
        </Tooltip>

    }
}

export const required = (props) => {

    return <TextField
        style={props.columnDef.type === 'numeric' ? { float: 'right' } : {}}
        type={props.columnDef.type === 'numeric' ? 'number' : 'text'}
        placeholder={props.columnDef.title}
        value={props.value === undefined ? '' : props.value}
        onChange={event => props.onChange(event.target.value)}
        multiline={props.columnDef.type !== 'numeric'}
        label={`${i18n.get("required")}`}
        rowsMax={props.columnDef.type !== 'numeric' ? 3 : 1}
        InputLabelProps={{
            shrink: true,
        }}
        InputProps={{
            style: {
                fontSize: 13,
            }
        }}
    />
}

export const _chips = (
    props,
    value,
    placeholder,
    label,
    getSuggestions,
    getDefaultSuggestions,
    maxLength,
    multiSection,
    renderSectionTitle,
    getSectionSuggestions,
    chipRenderer,
    debounceOff
) => {
    return (
        <Chips
            maxLength={maxLength ? maxLength : 1}
            value={value}
            getSuggestions={getSuggestions}
            getDefaultSuggestions={getDefaultSuggestions}
            onChanged={(value) => props.onChange(value)}
            placeholder={placeholder}
            label={label}
            multiSection={multiSection === true}
            renderSectionTitle={renderSectionTitle}
            getSectionSuggestions={getSectionSuggestions}
            chipRenderer={chipRenderer}
            debounceOff={debounceOff}
        />
    );
};

export const chips = (props, value, placeholder, label, getSuggestions, getDefaultSuggestions, onChange, maxLength, multiSection, renderSectionTitle, getSectionSuggestions, chipRenderer) => {

    return <Chips
        maxLength={maxLength ? maxLength : 1}
        value={value}
        getSuggestions={getSuggestions}
        getDefaultSuggestions={getDefaultSuggestions}
        onChanged={value => {
            if (onChange) {
                onChange(value);
            }
            props.onChange(value)
        }}
        placeholder={placeholder}
        label={label}
        multiSection={multiSection === true}
        renderSectionTitle={renderSectionTitle}
        getSectionSuggestions={getSectionSuggestions}
        chipRenderer={chipRenderer} />
}

export const updateSet = (changeSet, key, newObject, oldObject, equals) => {
    const _equals = equals ? equals : (newObject, oldObject) => { return newObject[key] === newObject[oldObject] };

    if (!_equals(newObject, oldObject)) {
        changeSet[key] = newObject[key];
    }
}

export const diffArray = (leftArray, rightArray) => {
    const diff = []
    for (const element of leftArray) {
        if (rightArray.filter((v) => deepEqual(element, v)).length === 0) {
            diff.push(element);
        }
    }

    return diff;
}

export const defaultCell = (props) => {
    return <CustomTableCell {...props} />
}

export const defaultFilter = (props) => {
    return <CustomFilterRow {...props} />
}

export const chipsFilter = (onChange, getValues, getSuggestions, getDefaultSuggestions) => (props) => {
    return (
        <Box display="flex" alignItems="center">
            <FilterIcon />
            {_chips(
                {
                    onChange: onChange
                        ? (items) => {
                            onChange(items, props);
                        }
                        : (items) => {
                            props.onFilterChanged(
                                props.columnDef.tableData.id,
                                items.map((item) => `,${item.value},`)
                            );
                        },
                },
                getValues(props.value || []),
                null,
                null,
                getSuggestions,
                getDefaultSuggestions,
                50
            )}
        </Box>
    );
};

export const DateRangeFilter = (props) => {
    const [starts, setStarts] = useState(null);
    const [ends, setEnds] = useState(null);
    const [focusedInput, setFocusedInput] = useState(null);

    const handleChangeRange = async (starts, ends) => {
        await setStarts(starts);
        await setEnds(ends);
    };

    return (
        <Grid container="true" spacing="0" display="flex" justify='flex-start' alignItems='flex-start' alignContent='flex-start' width="300px">
            <Grid item="true" justify="flex-start" alignItems='flex-start' alignContent='flex-start'>
                <DateRangePicker
                    customInputIcon={<FilterIcon />}
                    small
                    noBorder
                    showClearDates
                    justify={'flex-start'}
                    displayFormat={'DD.MM.YYYY'}
                    startDatePlaceholderText={i18n.get('dateTimePicker.starts')}
                    endDatePlaceholderText={i18n.get('dateTimePicker.ends')}
                    isOutsideRange={() => false}
                    startDate={starts}
                    startDateId="starts"
                    endDate={ends}
                    endDateId="ends"
                    anchorDirection="left"
                    horizontalMargin={0}
                    onClose={async ({ startDate, endDate }) => {
                        await handleChangeRange(startDate, endDate);
                        if (startDate !== starts || endDate !== ends)
                            props.onFilterChanged(props.columnDef.tableData.id, { startDate, endDate });
                    }}
                    onDatesChange={({ startDate, endDate }) => {
                        handleChangeRange(startDate, endDate);
                        if (startDate === null && endDate === null) {
                            props.onFilterChanged(props.columnDef.tableData.id, { startDate, endDate });
                        }
                    }}
                    focusedInput={focusedInput}
                    onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
                />
            </Grid>
        </Grid>
    );
};

export const RangeFilter = (props) => {

    const [from, setFrom] = useState(null);
    const [to, setTo] = useState(null);

    const handleFromChange = async (event) => {
        const val = event.target.value
        await setFrom(event.target.value === '' ? '' : Number(event.target.value));
        handleRangeChange({ from: val, to: to })
    };

    const handleToChange = async (event) => {
        const val = event.target.value
        await setTo(event.target.value === '' ? '' : Number(event.target.value));
        handleRangeChange({ from: from, to: val })
    };

    const handleRangeChange = debounce(async (range) => {
        props.onFilterChanged(props.columnDef.tableData.id, { from: range.from, to: range.to })
    }, 500);


    return (
        <Grid container spacing={2} width="250px" justify='flex-end' alignContent='flex-end' alignItems='flex-end'>

            <Grid item justify="flex-end" alignContent='flex-end'>
                <FilterIcon />
            </Grid>

            <Grid item justify="flex-end" alignContent='flex-end' alignItems='flex-end'>
                <Input
                    placeholder="von"
                    value={from}
                    margin="dense"
                    justify={'flex-end'}
                    onChange={handleFromChange}
                    inputProps={{
                        step: 1,
                        min: 0,
                        max: 999999,
                        type: 'number',
                        'aria-labelledby': 'range-slider',
                    }}
                />
            </Grid>

            <Grid item justify="flex-end" alignContent='flex-end' alignItems='flex-end'>
                <Input
                    placeholder="bis"
                    value={to}
                    margin="dense"
                    justify={'flex-end'}
                    onChange={handleToChange}
                    inputProps={{
                        step: 1,
                        min: 0,
                        max: 999999,
                        type: 'number',
                        'aria-labelledby': 'range-slider',
                    }}
                />
            </Grid>

        </Grid>
    );
};

export const findingDetailsOf = (rowData) => {
    const details = JSON.parse(rowData.details);
    switch (rowData.type) {
        case "LOW_BATTERY":
            return `Batterieladung bei ${details["battery"]}%`;
        case "LATE_RESPONSE":
            return `Tatsächlich: ${moment(details["latest"], 'X').tz('Europe/Berlin').format('DD.MM.YYYY HH:mm')}, erwartet: ${moment(details["expected"], 'X').tz('Europe/Berlin').format('DD.MM.YYYY HH:mm')}`;
        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_LO":
            return `nur ${details["numPoints"]} von erwarteten ${details["expectedPoints"]} Punkten`
        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_HI":
            return `${details["numPoints"]} statt ${details["expectedPoints"]} Punkte`
        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_NULL":
            return `kein Durchfluss`
        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_LO":
            return `nur ${details["actual"]} ml von erwarteten ${details["expected"]} ml`
        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_HI":
            return `${details["actual"]} ml statt ${details["expected"]} ml`
        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_MAX_DISTANCE_NULL":
            return `größte gemessene Entfernung ist 0 mm`
        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_MIN_DISTANCE_NULL":
            return `kleinste gemessene Entfernung ist 0 mm`
        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_HI":
            return `${details["distMax"]} mm gemessen`
        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_LO":
            return `${details["distMin"]} mm gemessen`
        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_HI":
            return `Maximum: ${details["distMax"]} mm, Durchschnitt: ${details["distMean"]} mm`
        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_LO":
            return `Minimum: ${details["distMin"]} mm, Durchschnitt: ${details["distMean"]} mm`
        default:
            return rowData.details
    }
}